import MangaCard from '@/components/base/MangaCard';
import { mangaList } from '@/mocks/manga';

export default function PopularSection() {
  const popular = [...mangaList]
    .sort((a, b) => b.views - a.views)
    .slice(0, 8);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950">
              人气推荐
            </h2>
            <p className="mt-2 text-sm text-foreground-600">千万读者都在看的热门漫画</p>
          </div>
          <a href="/category/shonen" className="hidden sm:flex items-center gap-1 text-sm text-accent-500 hover:text-accent-600 transition-colors whitespace-nowrap">
            查看全部 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {popular.map((manga) => (
            <MangaCard key={manga.id} manga={manga} />
          ))}
        </div>
      </div>
    </section>
  );
}